import gql from 'graphql-tag'

export const ASSET_MUTATION_UPDATE = gql`
  mutation UpdateUIAssets($input: [UpdateUIAssetInputType]!) {
    updateUIAssets(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateUIAssets {
        assetType
        value
        module
        isActive
        fileName
        isDefault
      }
    }
  }
`
export const GET_MUTATION_ASSET = gql`
  query UiAsset($filter: GetUIAssetInputType) {
    uiAssets(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      uiAssets {
        assetType
        value
        module
        isActive
        fileName
        isDefault
      }
    }
  }
`
